export default __webpack_public_path__ + "static/media/pendrive.6a7d8834.png";